import classNames from 'classnames/bind';
import React from 'react';
import { Link } from 'react-router-dom';
import { getIssuerRoute } from '../../../../utils/navigationUtils';
import WeightIcon from '../../../WeightIcon';
import styles from './CompanyTitle.module.scss';

const cx = classNames.bind(styles);

interface CompanyTitleProps {
  issuerTag: string;
  displayName: string;
  weighting?: string;
  hasLink?: boolean;
  textOverflowHidden?: Boolean;
}

const CompanyTitle = ({
  issuerTag,
  displayName,
  weighting,
  hasLink,
  textOverflowHidden,
}: CompanyTitleProps): React.ReactElement => {
  return (
    <div className={cx('body')} data-testid={`company-title-${issuerTag}`}>
      {weighting && (
        <span className={cx('icon-container')}>
          <WeightIcon weighting={weighting} />
        </span>
      )}
      {hasLink ? (
        <Link
          to={getIssuerRoute(issuerTag)}
          data-testid="company-link"
          className={cx({ 'text-overflow-hidden': textOverflowHidden })}
        >
          {displayName}
        </Link>
      ) : (
        <span data-testid="company-name">{displayName}</span>
      )}
    </div>
  );
};

export default CompanyTitle;
